var FcHorizontalBarChartModule = /** @class */ (function () {
    function FcHorizontalBarChartModule() {
    }
    return FcHorizontalBarChartModule;
}());
export { FcHorizontalBarChartModule };
